const SCROLLABLE_OVERFLOW = /(auto|scroll|overlay)/;
const DEFAULT_STICKY_HEADER_OFFSET = 220;
const SCROLL_BEFORE_OFFSET = 100;

export const RECORD_STICKY_BOOKMARKS_ATTR = 'data-record-sticky-bookmarks';

export const getScrollableParent = (element: HTMLElement | null): HTMLElement | null => {
  if (!element) return null;

  let parent = element.parentElement;

  while (parent) {
    const style = window.getComputedStyle(parent);
    const isScrollable = SCROLLABLE_OVERFLOW.test(style.overflowY) && parent.scrollHeight > parent.clientHeight;

    if (isScrollable) {
      return parent;
    }

    parent = parent.parentElement;
  }

  return null;
};

export const getStickyHeaderOffset = (scrollBeforeOffset = SCROLL_BEFORE_OFFSET): number => {
  const stickyHeader = document.querySelector('[data-testid="detail-sticky-header"]');
  const stickyBookmarks = document.querySelector(`[${RECORD_STICKY_BOOKMARKS_ATTR}="true"]`);
  const bookmarksHeight = stickyBookmarks instanceof HTMLElement ? stickyBookmarks.getBoundingClientRect().height : 0;

  if (!(stickyHeader instanceof HTMLElement) && bookmarksHeight === 0) {
    return DEFAULT_STICKY_HEADER_OFFSET;
  }

  const headerHeight = stickyHeader instanceof HTMLElement ? stickyHeader.getBoundingClientRect().height : 0;

  return headerHeight + bookmarksHeight + scrollBeforeOffset;
};

export const scrollExpandedSectionIntoView = (element: HTMLElement | null): void => {
  if (!element) return;

  const offset = getStickyHeaderOffset();
  const scrollParent = getScrollableParent(element);
  const targetElement = element.querySelector<HTMLElement>('.MuiAccordionSummary-root') ?? element;

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      if (!scrollParent) {
        const targetTop = window.scrollY + targetElement.getBoundingClientRect().top - offset;

        window.scrollTo({
          top: Math.max(targetTop, 0),
          behavior: 'smooth',
        });

        return;
      }

      const container = scrollParent;
      const elementRect = targetElement.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();

      const targetTop = container.scrollTop + elementRect.top - containerRect.top - offset;

      container.scrollTo({
        top: Math.max(targetTop, 0),
        behavior: 'smooth',
      });
    });
  });
};
